import type { Underlying } from 'models/underlying';
import type { Collection } from 'state/utils/types';
import { LoadingStatus } from 'utils/status';

export interface BasketOptimizerResultRow {
  underlyingIds: string[];
  price: number;
}

export interface UnderlyingTag {
  label: string;
  value: string;
  isHighlighted: boolean;
  isDisabled?: boolean;
  rawValue?: Underlying;
}

export type BasketOptimizer = Readonly<{
  status: LoadingStatus;
  couponFrom?: number;
  couponTo?: number;
  errorMessage?: string;
  estimatedComputationTimeInSeconds?: number;
  isMutuallyExclusive: boolean;
  targetBasketSize?: number;
  isUnderlyingsAdditionFailed?: boolean;
  optimizationStartDate?: Date;
  optimizeId?: string;
  result: BasketOptimizerResultRow[];
  underlyingsTags?: UnderlyingTag[];
}>;

export type BasketOptimizerState = Collection<BasketOptimizer>;

export const initialBasketOptimizerState = (): BasketOptimizer => ({
  status: 'idle',
  isMutuallyExclusive: false,
  underlyingsTags: undefined,
  result: [],
});

export type BasketOptimizerResultResponse = {
  optimiseId: string;
} & (
  | {
      messageError: string;
      status: 1;
    }
  | {
      result: BasketOptimizerResultRow[];
      status: 0;
    }
);
